// extracted by mini-css-extract-plugin
module.exports = {"desktop":"_type_desktop__3I4ll","tablet":"_type_tablet__2oPNj","mobile":"_type_mobile__3C6Sm","center":"_type_center__2zAS7"};